import React, { useEffect, useState } from "react";
import Select from 'react-select';

const Search = ({ itemList = [], webText, webLanguage, webTheme, callback }) => {

    const [searchOption, setSearchOption] = useState(null);
    const [searchOptions, setSearchOptions] = useState([]);

    useEffect(() => {
        if (itemList) {
            let options = [];
            for (let i = 0; i < itemList.length; i++) {
                options.push({ value: itemList[i].title, label: itemList[i].title });
            };
            setSearchOptions(options);
        };
    }, [itemList]);



    const customStyles = webTheme === "dark" ? {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: "#222831",
        borderColor: "#00ADB5",
        borderWidth: '2px',
        boxShadow: null,
        '&:hover': {
          borderColor: "#EEEEEE",
          borderWidth: '2px',
          cursor: 'pointer'
        }
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "#EEEEEE",
      }),
      input: (provided, state) => ({
        ...provided,
        caretColor: "#EEEEEE",
        color: "#EEEEEE"
      }),
      option: (provided, state) => ({
        ...provided,
        color: "#222831",
        backgroundColor: state.isSelected ? "#00ADB5" : "#EEEEEE",
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: "lightgray"
        }
      }),
      menuList: (provided, state) => ({
        ...provided,
        backgroundColor: '#EEEEEE',
        borderRadius: "5px"
      })
    }
    :
    {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: "#EEEEEE",
        borderColor: "#00ADB5",
        borderWidth: '2px',
        boxShadow: "null",
        '&:hover': {
          borderColor: "#222831",
          borderWidth: '2px',
          cursor: 'pointer'
        }
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "#222831"
      }),
      input: (provided, state) => ({
        ...provided,
        caretColor: "#222831",
        color: "#222831"
      }),
      option: (provided, state) => ({
        ...provided,
        color: "#EEEEEE",
        backgroundColor: state.isSelected ? "#00ADB5" : state.isFocused ? 'lightgray' : "#222831",
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: "lightgray"
        }
      }),
      menuList: (provided, state) => ({
        ...provided,
        backgroundColor: '#222831',
        borderRadius: "5px"
      })
    };

    const handleChangeSearch = (selectedOption) => {
        setSearchOption(selectedOption);
        callback(selectedOption);
    };

    return (
        <Select
          value={searchOption}
          placeholder={webText.searchFilterPlaceholder}
          onChange={handleChangeSearch}
          options={searchOptions}
          styles={customStyles}
          isClearable={true}
        />
    );
};

export default Search;